export const SCOPE = 'https://graph.microsoft.com/user.read';
